import React from 'react';
import { styled } from '@linaria/react';
import { SkeletonLoader } from '@daedalus/atlas/SkeletonLoader';
const Wrapper = /*#__PURE__*/styled('div')({
  name: "Wrapper",
  class: "w1fy67rw",
  propsAsIs: false
});
const ActionWrapper = /*#__PURE__*/styled('div')({
  name: "ActionWrapper",
  class: "a1rbscnd",
  propsAsIs: false
});
export const DateGuestInputLoading = () => {
  return <Wrapper>
      <ActionWrapper className="__withBorder">
        <SkeletonLoader width={20} height={20} marginTop={0} />
        <div>
          <SkeletonLoader width={119} height={20} marginTop={0} />
          <SkeletonLoader width={95} height={16} marginTop={0} />
        </div>
      </ActionWrapper>

      <ActionWrapper>
        <SkeletonLoader width={20} height={20} marginTop={0} />
        <div>
          <SkeletonLoader width={119} height={20} marginTop={0} />
          <SkeletonLoader width={95} height={16} marginTop={0} />
        </div>
      </ActionWrapper>
    </Wrapper>;
};

require("./DateGuestInputLoading.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./DateGuestInputLoading.tsx");